import {
  DataTableCollapsibleRow,
  Dialog,
  FormInput,
  FormSelect,
  Heading,
  Loader,
} from "@/components";
import useBillingConfig from "./useBillingConfig";
import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import {
  frequencyOptions,
  transactionTypeOptions,
  SEARCH_CRITERIA,
  SEARCH_TYPE,
  searchType,
} from "../consts";

const BillingConfig = () => {
  const {
    breadcrumbData,
    communityDetail,
    isMobile,
    onAddBillingConfig,
    setGlobalFilter,
    globalFilter,
    form,
    onSubmit,
    requiredFields,
    columns,
    onClear,
    isConfigLoading,
    isConfigRefetching,
    configList,
    billingCategory,
    isLoadingBillingCategory,
    hasAddPermission,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    onBackClick,
    subColumns,
    tableData,
    onRowExpanded,
    currentFinancialYear,
    openCategoryDialog,
    setOpenCategoryDialog,
    selectedBillingCategories,
    sorting,
    setSorting,
  } = useBillingConfig();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={<span>Billing Configuration - {communityDetail?.communityName} <span className="text-[12px]">(FY-{currentFinancialYear})</span> </span>}
            breadcrumbData={breadcrumbData}
            showBack
            onBackClick={onBackClick}
          />
          {isMobile &&
            hasAddPermission && (
              <Button
                className="px-2"
                onClick={onAddBillingConfig}
                disabled={
                  isConfigLoading ||
                  isConfigRefetching
                }
              >
                + Add Billing Config
              </Button>
            )}
        </div>

        <div className="flex flex-row items-center gap-4">
          {!isMobile &&
            hasAddPermission && (
              <Button
                onClick={onAddBillingConfig}
                disabled={
                  isConfigLoading ||
                  isConfigRefetching
                }
              >
                + Add Billing Config
              </Button>
            )}
        </div>
      </div>

      {isLoadingBillingCategory ? (
        <></>
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px] mb-[30px]">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                <FormSelect
                  name={SEARCH_TYPE}
                  control={form.control}
                  label="Search Type"
                  placeholder="Please select"
                  error={errors[SEARCH_TYPE]?.message}
                  isRequired={requiredFields.includes(SEARCH_TYPE)}
                  options={searchType}
                />
                {form.watch(SEARCH_TYPE) == "billingCategoryIds" ? (
                  <FormSelect
                    name={SEARCH_CRITERIA}
                    control={form.control}
                    label="Billing Category"
                    placeholder="Please select"
                    error={errors[SEARCH_CRITERIA]?.message}
                    isRequired={requiredFields.includes(SEARCH_CRITERIA)}
                    options={(billingCategory?.data || [])?.map(
                      (data: any) => ({
                        value: data?.billingCategoryId?.toString(),
                        label: data?.categoryName,
                      })
                    )}
                  />
                ) : form.watch(SEARCH_TYPE) == "transactionType" ? (
                  <FormSelect
                    name={SEARCH_CRITERIA}
                    control={form.control}
                    label="Transaction Type"
                    placeholder="Please select"
                    error={errors[SEARCH_CRITERIA]?.message}
                    isRequired={requiredFields.includes(SEARCH_CRITERIA)}
                    options={transactionTypeOptions}
                  />
                ) : form.watch(SEARCH_TYPE) == "frequency" ? (
                  <FormSelect
                    name={SEARCH_CRITERIA}
                    control={form.control}
                    label="Frequency"
                    placeholder="Please select"
                    error={errors[SEARCH_CRITERIA]?.message}
                    isRequired={requiredFields.includes(SEARCH_CRITERIA)}
                    options={frequencyOptions}
                  />
                ) : (
                  <FormInput
                    name={SEARCH_CRITERIA}
                    control={form.control}
                    label="Search Criteria"
                    placeholder="Please enter"
                    error={errors[SEARCH_CRITERIA]?.message}
                    isRequired={requiredFields.includes(SEARCH_CRITERIA)}
                  />
                )}

                <div className="flex flex-row justify-end gap-3 pt-3">
                  <Button type="submit">Search</Button>
                  <Button variant="outline" type="button" onClick={onClear}>
                    Clear
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      )}

      {isConfigLoading || isConfigRefetching ? (
        <Loader />
      ) : (
        <DataTableCollapsibleRow
          columns={columns}
          nestedColumns={[subColumns]}
          data={tableData || []}
          onExpand={onRowExpanded}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalPages={Math.ceil(configList?.total / pageSize)}
          totalRecords={configList?.total}
          serverSidePagination={true}
          sorting={sorting}
          onSortingChange={setSorting}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
          hideFooter={false}
        />
      )}
      <Dialog
        open={openCategoryDialog}
        setOpen={setOpenCategoryDialog}
        title="Category List">
          <ul className="my-4 list-disc pl-4">
            {
              selectedBillingCategories?.map((data: any) => {
                return (
                  <li>
                    {
                      billingCategory?.data?.find(
                        (val: any) =>
                          data?.trim()?.toString() == val.billingCategoryId?.toString()
                      )?.categoryName || ""
                    }
                  </li>
                );
              })
            }
          </ul>
      </Dialog>
    </div>
  );
};

export default BillingConfig;
